/** 系统主色：与 Pad 登录页渐变终点一致 */
export const PRIMARY_COLOR = "#1D4ED8";

/** 用于 CSS `rgba(var(--color-primary-rgb), α)` */
export const PRIMARY_COLOR_RGB = "29, 78, 216";

/** 主题色：后台、设备管理、平板配套页面统一使用 */
export const WATER_THEME = {
  primary: PRIMARY_COLOR,
  primaryRgb: PRIMARY_COLOR_RGB,
  primaryDeep: "#1E40AF",
  primaryHover: "#2563EB",
  primaryActive: "#1E3A8A",
  primaryLight: "#EFF6FF",
  menuStart: "#0F172A",
  menuMiddle: "#1D4ED8",
  menuEnd: "#1D4ED8",
  secondary: "#60A5FA",
  background: "#F3F6FA",
  text: "#0F172A",
  border: "#BFDBFE",
  success: "#22C55E",
  warning: "#F59E0B",
  error: "#EF4444",
};
